import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useOnboardingPlannerViewSectionContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import RiskToleranceAnswers from 'Components/RiskTolerance/RiskToleranceAnswers';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0, 3),
  },
  content: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(0, 2),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  client: {
    marginBottom: theme.spacing(5),
  },
}));

export default function RiskToleranceManualLayout() {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();

  const classes = useStyles();

  const [sectionDataResource] = resource.attr('sectionData');
  const [riskToleranceOptions] = useState(sectionDataResource.meta().field('clients').attr('arrayDef').template.find(t => t.name === 'riskTolerance'));

  return (
    <div className={classes.root}>
      <OnboardingPlannerViewSectionHeader
        className={classes.header}
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
      />
      <div className={classes.content}>
        {sectionDataResource.attr('clients')?.resources().list().map((client) => (<RiskToleranceAnswers
          key={client.id()}
          name={client.attr('name')}
          value={client.attr('riskTolerance')}
          warning={client.attr('warning')}
          questions={client.attr('riskToleranceQuestions')}
          className={classes.client}
          metaOptions={riskToleranceOptions}
        />))}
      </div>
    </div>
  );
}

RiskToleranceManualLayout.propTypes = {
};

RiskToleranceManualLayout.defaultProps = {
};
